import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { useApplicationStatusByFundraisingId } from '@/hooks/shared/useApplicationStatusByFundraisingId';
import s from './index.module.scss';

export const FundraisingStatusApplication = ({ fundraisingId, hideTitle, className }) => {
  const { t } = useTranslation('fundraising');
  const { application } = useApplicationStatusByFundraisingId(fundraisingId);

  const applicationFundsSum =
    application?.new_funds +
      application?.refinancings.reduce((sum, item) => {
        if (item.checked) {
          sum += item.amount
        }
        return sum;
      }, 0) || 0;

  return (
    <div className={className}>
      {!hideTitle && (
        <h3 className={classnames(s.title, 'f-h3 f-500')}>
          {t('fr_status.fundraising_goal_for_next_round')}
        </h3>
      )}
      <div className={classnames(s.statistics)}>
        {!!application.new_funds && (
          <div className={classnames(s.row, 'f-body')}>
            <div className="f-small-accent">{t('fr_status.new_funds')}</div>
            <div className="f-small-regular">{prettyFloatMoney(application.new_funds)}</div>
            <div className={s.edit} />
          </div>
        )}
        {application?.refinancings.filter(refin => refin.checked).map(refinance => (
          <div key={refinance.title} className={classnames(s.row, 'f-body')}>
            <div className="f-small-accent">
              {t('fr_status.refinance', { name: refinance.title })}
            </div>
            <div className="f-small-regular">{prettyFloatMoney(refinance.amount)}</div>
          </div>
        ))}
        <div className={classnames(s.row, s.total, 'f-body')}>
          <div className="f-small-accent">{t('fr_status.total_fundraising_goal')}</div>
          <div className="f-small-accent">{prettyFloatMoney(applicationFundsSum)}</div>
        </div>
      </div>
    </div>
  );
};
